import * as am5 from '@amcharts/amcharts5';
import worldLow from '@amcharts/amcharts5-geodata/worldLow';
import * as am5map from '@amcharts/amcharts5/map';
import { applyClickView } from './applyClickView';
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";

export const applyDefault = (
  root: any,
  polygonSeries: any,
  backgroundSeries: any,
  mainChart: any,
  selectedCountryPolygon: any,
  setPolygonSeries: any,
  handleSelectCountry: any,
) => {
  // Create main polygon series for countries

    am5plugins_exporting.Exporting.new(root, {
        menu: am5plugins_exporting.ExportingMenu.new(root, {}),
        backgroundColor: am5.color(0xffffff),
    });


  polygonSeries = mainChart.series.push(
    am5map.MapPolygonSeries.new(root, {
      geoJSON: worldLow,
      valueField: 'value',
      calculateAggregates: true,
    }),
  );

  polygonSeries.mapPolygons.template.setAll({
    // tooltipText: '{name}',
    toggleKey: 'active',
    interactive: true,
  });

  polygonSeries.mapPolygons.template.states.create('hover', {
    fill: am5.color(0x92a7d6),
    stroke: am5.color(0x2e8bc0),
  });

  polygonSeries.mapPolygons.template.states.create('active', {
      strokeWidth: 6,
  });
  polygonSeries.mapPolygons.template.setAll({
    // tooltipText: '{name}: {value}',
    tooltipText: '{name}',
  });

  setPolygonSeries(polygonSeries);

  backgroundSeries = mainChart.series.unshift(
    am5map.MapPolygonSeries.new(root, {}),
  );

    polygonSeries.mapPolygons.template.setAll({
        fill: am5.color(0x346078),
        stroke: am5.color(0x2e8bc0),
        strokeWidth: 2,
        fillOpacity: 1,
        strokeOpacity: 1,
    });

    backgroundSeries.mapPolygons.template.setAll({
        fill: am5.color(0x5ea2d1),
        stroke: am5.color(0xd4f1f9),
        opacity: .2
    });

  backgroundSeries.data.push({
    geometry: am5map.getGeoRectangle(90, 180, -90, -180),
  });

  mainChart.chartContainer.set(
    'background',
    am5.Rectangle.new(root, {
      fill: am5.color(0xd4f1f9),
      fillOpacity: 0,
    }),
  );

  // Make stuff animate on load
  mainChart.appear(1000, 100);

  // initial position UAE
  mainChart.animate({
    key: 'rotationX',
    to: -53.847818,
    duration: 1500,
    easing: am5.ease.inOut(am5.ease.cubic),
  });

  mainChart.animate({
    key: 'rotationY',
    to: -23.424076,
    duration: 1500,
    easing: am5.ease.inOut(am5.ease.cubic),
  });

  applyClickView(
    polygonSeries,
    mainChart,
    selectedCountryPolygon,
    handleSelectCountry,
  );
};
